import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={8} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Consultant">
                <h1>
                  <span className="orange">Digital Strategy</span> Consultant
                </h1>
              </div>
              <div className=" banner_content_txt listing_flex">
                <p>
                  Raise Your vision and increase your success. With our
                  knowledge, navigate the digital landscape confidently and
                  accomplish astonishing growth. Your success story starts here
                  with our Digital Strategy Consultant Services. Our digital
                  strategy consulting services exemplify user-centric, digitized
                  notions that pave the way for unmatched, technology-powered
                  transformations, creating ultimate experiences.
                </p>
                <ul>
                  <li>Unveiling Business Needs</li>
                  <li>Precise Platform Objectives</li>
                  <li>Clientele & Social Immersion</li>
                  <li>Pioneering Experience-Driven Innovation</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={4} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
